module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "votefriend",
    attrs: {
      "id": "votefriend"
    }
  }, [_c('div', {
    staticClass: "menubar clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pcDisp),
      expression: "pcDisp"
    }],
    staticClass: "right-section"
  }, [_c('div', {
    staticClass: "menu"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][1]))])]), _vm._v(" "), _c('a', {
    ref: "menu2",
    attrs: {
      "href": "#vote"
    },
    on: {
      "click": function($event) {
        _vm.toggleClickMenu('2')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][2]))])]), _vm._v(" "), _c('a', {
    ref: "menu3",
    attrs: {
      "href": "#rule"
    },
    on: {
      "click": function($event) {
        _vm.toggleClickMenu('3')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][3]))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-img"
  }, [(_vm.profile.namimage) ? _c('img', {
    attrs: {
      "src": _vm.profile.namimage
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.profile.namimage) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/no_image.png")
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pcDisp),
      expression: "!pcDisp"
    }],
    staticClass: "right-section-mb"
  }, [_c('div', {
    staticClass: "menu-mb",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "rec"
  }), _vm._v(" "), _c('div', {
    staticClass: "rec"
  }), _vm._v(" "), _c('div', {
    staticClass: "rec"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuDisp),
      expression: "menuDisp"
    }],
    staticClass: "menu-list clearfix",
    class: [_vm.menuDisp ? 'animated slideInRight' : 'animated slideOutRight']
  }, [_c('div', {
    staticClass: "close-icon clearfix",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile-img clearfix"
  }, [(_vm.profile.namimage) ? _c('img', {
    attrs: {
      "src": _vm.profile.namimage
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.profile.namimage) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/no_image.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "list",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][1]))])]), _vm._v(" "), _c('a', {
    ref: "menu2",
    staticClass: "list",
    attrs: {
      "href": "#vote"
    },
    on: {
      "click": function($event) {
        _vm.toggleClickMenu('2')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][2]))])]), _vm._v(" "), _c('a', {
    ref: "menu3",
    staticClass: "list",
    attrs: {
      "href": "#rule"
    },
    on: {
      "click": function($event) {
        _vm.toggleClickMenu('3')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][3]))])])], 1)]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "home"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (-0.1),
      expression: "-0.1"
    }],
    staticClass: "header clearfix"
  }, [_c('div', {
    staticClass: "col-sm-2 clear-padding"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.1),
      expression: "0.1"
    }],
    staticClass: "col-xs-12 col-sm-8 campaign-text"
  }, [_c('div', {
    staticClass: "campaign-name"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][4]))]), _vm._v(" "), _c('div', {
    staticClass: "taglines"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][5]))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "vote"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (-0.1),
      expression: "-0.1"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "topic-box"
  }, [_c('div', {
    staticClass: "topic"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-4 clear-padding"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-sm-4 text1 clear-padding"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][6]))]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-4 clear-padding"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-sm-4 text2 clear-padding"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][7]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-4 clear-padding"
  })])])]), _vm._v(" "), _c('vote-friend-list', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "nowLang": _vm.app.nowLang,
      "friendLists": _vm.friendLists,
      "pcDisp": _vm.pcDisp,
      "pageCurrent": _vm.pageCurrent,
      "maxPage": _vm.maxPage,
      "numberPerPage": _vm.numberPerPage,
      "setPageCurrent": _vm.setPageCurrent,
      "setMaxPage": _vm.setMaxPage,
      "togglePopup": _vm.togglePopup
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "rule"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rule-box clearfix"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][11]))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][12]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 clear-padding"
  }, [_c('div', {
    staticClass: "how-to"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][13]))]), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_c('i', {
    staticClass: "icon fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "rule-list"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][14]))])]), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_c('i', {
    staticClass: "icon fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "rule-list"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][15]))])]), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_c('i', {
    staticClass: "icon fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "rule-list"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][16]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "score-box clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 clearfix"
  }, [_c('img', {
    staticClass: "score-icon",
    attrs: {
      "src": require("./images/icon_star.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][17]))])]), _vm._v(" "), _c('div', {
    staticClass: "score-row clearfix"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][18]))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][19]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][20]))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][21]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][22]))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][23]))])])]), _vm._v(" "), _c('div', {
    staticClass: "score-row clearfix"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][24]))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][25]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][26]))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][27]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "annoucement-box clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][28]))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][29]) + " " + _vm._s(_vm.quarterly) + "\n          " + _vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][30]))]), _vm._v(" "), _c('div', {
    staticClass: "topic2"
  }, [_c('img', {
    staticClass: "prize-icon",
    attrs: {
      "src": require("./images/icon_reward.png")
    }
  }), _vm._v("\n          " + _vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][31]) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][32]))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['VOTEFRIEND'][33]))])])], 1), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('popup', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "popup": _vm.popup,
      "postVotefriendSave": _vm.postVotefriendSave,
      "currentCodempid": _vm.codempid,
      "pcDisp": _vm.pcDisp
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("./images/Peopleplus_Logo-01.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-2 season-icon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/label.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 col-sm-4 clear-padding"
  }, [_c('img', {
    staticClass: "heart",
    attrs: {
      "src": require("./images/icon_heart.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4 clear-padding"
  }, [_c('img', {
    staticClass: "hand",
    attrs: {
      "src": require("./images/image_content.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "announce-icon"
  }, [_c('img', {
    staticClass: "score-icon",
    attrs: {
      "src": require("./images/icon_megaphone.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col-xs-12 copy"
  }, [_vm._v("Copyright 2017 People Plus Software Co., Ltd. All Rights Reserved.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7082386d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/votefriend/component.vue
// module id = 3855
// module chunks = 1